import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { startOAuth, oauthErrorMessage } from '../services/oauthRelay';
import './AuthPages.css';

export default function SignUpPage() {
  const { register } = useAuth();

  const [form, setForm] = useState({ full_name: '', email: '', password: '', confirm_password: '' });
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(oauthErrorMessage(searchParams.get('auth_error')));
  const [success, setSuccess] = useState('');
  const [busy, setBusy] = useState(false);

  const set = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setBusy(true);
    try {
      const data = await register(form);
      setSuccess(data.message || 'Registration successful! Check your email to verify your account.');
    } catch (err) {
      setError(err.response?.data?.detail || 'Registration failed.');
    } finally {
      setBusy(false);
    }
  };

  /* Social sign-up goes through the backend relay, so it works on a company's
     own subdomain too — see services/oauthRelay.js. */
  const handleGoogleSignUp = () => startOAuth('google', '/');
  const handleFacebookSignUp = () => startOAuth('facebook', '/');

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">AI Broker</div>
        <h1>Create your account</h1>
        <p className="auth-subtitle">Start your property search with AI</p>

        {error && <div className="auth-error">{error}</div>}
        {success && <div className="auth-success">{success}</div>}

        {!success && (
          <>
            <form onSubmit={handleSubmit} className="auth-form">
              <label>
                Full name
                <input type="text" value={form.full_name} onChange={set('full_name')} required placeholder="Mohamed Mostafa" />
              </label>
              <label>
                Email
                <input type="email" value={form.email} onChange={set('email')} required placeholder="you@example.com" />
              </label>
              <label>
                Password
                <input type="password" value={form.password} onChange={set('password')} required placeholder="Min 8 chars, 1 upper, 1 lower, 1 digit" />
              </label>
              <label>
                Confirm password
                <input type="password" value={form.confirm_password} onChange={set('confirm_password')} required placeholder="Re-enter password" />
              </label>
              <button type="submit" className="auth-btn primary" disabled={busy}>
                {busy ? 'Creating account…' : 'Create account'}
              </button>
            </form>

            <div className="auth-divider"><span>or</span></div>

            <div className="auth-social">
              <button type="button" className="auth-btn google" onClick={handleGoogleSignUp} disabled={busy}>
                <svg viewBox="0 0 24 24" width="20" height="20">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                Sign up with Google
              </button>
              <button type="button" className="auth-btn facebook" onClick={handleFacebookSignUp} disabled={busy}>
                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.99 3.66 9.12 8.44 9.88v-6.99H7.9V12h2.54V9.8c0-2.51 1.49-3.89 3.78-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.44 2.89h-2.34v6.99C18.34 21.12 22 16.99 22 12z"/></svg>
                Sign up with Facebook
              </button>
            </div>
          </>
        )}

        <p className="auth-footer">
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
